import { Link } from 'react-router-dom';
import { NotificationList } from '../components/notifications/NotificationList';

export const NotificationsPage = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-6">
      <div className="mb-4 flex justify-end">
        <Link
          to="/notifications/settings"
          className="text-sm text-blue-600 hover:text-blue-800 font-medium"
        >
          ⚙️ Indstillinger
        </Link>
      </div>
      <NotificationList />
    </div>
  );
};
